import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>Route Couldn't Found</h1>
        </div>
    );
};

export default NoMatch;